(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-slider-section"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function(){
  $('.blog-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_product_finish_guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.mt-finish').forEach(function (root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.mt-finish__item'));
    var oneAtATime = root.dataset.oneOpen === 'true';

    // Only one panel open at a time (opt-in via section setting)
    if (oneAtATime) {
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    }

    // Quick-pick links open the matching finish and scroll to it
    root.querySelectorAll('[data-finish-jump]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = root.querySelector('#' + link.dataset.finishJump);
        if (!target) return;
        e.preventDefault();
        target.open = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_product_info"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-mt-phero2]').forEach(function (root) {
    var selects = root.querySelectorAll('[data-mt-select]');
    var variantSelect = root.querySelector('[data-mt-variant-id]');
    var addBtn = root.querySelector('[data-mt-add]');
    var form = root.querySelector('form');
    var allOptions = root.querySelectorAll('[data-mt-select-option]');
    if (!variantSelect) return;

    // Read every real variant once: its option values (by position) and stock state.
    var variants = Array.prototype.map.call(variantSelect.querySelectorAll('option'), function (o) {
      return {
        id: o.value,
        options: (o.getAttribute('data-options') || '').split('~~'),
        soldOut: o.disabled
      };
    });

    var chosen = {}; // { optionPosition: value }

    // Does a real variant exist with `val` at `pos` AND all other current selections?
    function comboExists(pos, val) {
      return variants.some(function (v) {
        if (v.options[pos - 1] !== val) return false;
        return Object.keys(chosen).every(function (p) {
          var position = parseInt(p, 10);
          if (position === pos) return true;
          return v.options[position - 1] === chosen[p];
        });
      });
    }

    // Strike out and disable every value that has no real variant with the current selection.
    function refreshOptions() {
      allOptions.forEach(function (opt) {
        var pos = parseInt(opt.getAttribute('data-option-position'), 10);
        var val = opt.getAttribute('data-value');
        var ok = comboExists(pos, val);
        opt.disabled = !ok;
        opt.classList.toggle('is-unavailable', !ok);
        opt.setAttribute('aria-disabled', ok ? 'false' : 'true');
      });
    }

    // Only a fully chosen, real variant can be added to the basket.
    function resolveVariant() {
      var matched = null;

      if (Object.keys(chosen).length === selects.length) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var isMatch = Object.keys(chosen).every(function (p) {
            return v.options[parseInt(p, 10) - 1] === chosen[p];
          });
          if (isMatch) { matched = v; break; }
        }
      }

      if (matched) {
        variantSelect.value = matched.id;
        if (addBtn) addBtn.disabled = matched.soldOut;
      } else {
        variantSelect.selectedIndex = -1; // nothing gets submitted
        if (addBtn) addBtn.disabled = true;
      }
    }

    selects.forEach(function (sel) {
      var btn = sel.querySelector('[data-mt-select-btn]');
      var list = sel.querySelector('[data-mt-select-list]');
      var label = sel.querySelector('[data-mt-select-label]');

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        selects.forEach(function (s) {
          s.querySelector('[data-mt-select-btn]').setAttribute('aria-expanded', 'false');
          s.querySelector('[data-mt-select-list]').hidden = true;
        });
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          list.hidden = false;
        }
      });

      list.querySelectorAll('[data-mt-select-option]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (opt.disabled) return;
          var pos = opt.getAttribute('data-option-position');
          var val = opt.getAttribute('data-value');
          chosen[pos] = val;
          label.textContent = val;
          btn.setAttribute('aria-expanded', 'false');
          list.hidden = true;
          refreshOptions();
          resolveVariant();
        });
      });
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) return;
      if (e.target.closest('[data-mt-select]')) return;
      selects.forEach(function (s) {
        s.querySelector('[data-mt-select-btn]').setAttribute('aria-expanded', 'false');
        s.querySelector('[data-mt-select-list]').hidden = true;
      });
    });

    // Safety net: never submit without a valid, in-stock variant.
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!variantSelect.value || (addBtn && addBtn.disabled)) e.preventDefault();
      });
    }

    // Products with a single variant (e.g. "Default Title"): preselect it.
    if (variants.length === 1) {
      selects.forEach(function (sel, i) {
        chosen[String(i + 1)] = variants[0].options[i];
        sel.querySelector('[data-mt-select-label]').textContent = variants[0].options[i];
      });
    }

    refreshOptions();
    resolveVariant();

    var infoBtn = root.querySelector('[data-mt-info-btn]');
    var infoBody = root.querySelector('[data-mt-info-body]');
    if (infoBtn && infoBody) {
      infoBtn.addEventListener('click', function () {
        var open = infoBtn.getAttribute('aria-expanded') === 'true';
        infoBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
        infoBody.hidden = open;
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  new Swiper('.hero-slider', {
    loop: true,
    speed: 800,
    autoplay: {
      delay: 10000000000,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faq-section"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".faq-item");

  items.forEach(item => {
    const question = item.querySelector(".faq-question");

    question.addEventListener("click", () => {
      item.classList.toggle("active");
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["post-slider-section"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function(){
  $('.post-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});


  } catch(e) { console.error(e); }
})();
})();
